// Header.jsx
import React, { useState } from 'react';
import { Box, Link, Drawer, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { classes } from '../../styles/HeaderStyle';
import LoginModal from './LoginModal'; // Adjust path if needed
import SignupModal from './SignupModal';

function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [signupModalOpen, setSignupModalOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleDrawer = (open) => (event) => {
    // Prevent toggle on Tab/Shift keys for better accessibility
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const handlePricingClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/home') {
      const pricingSection = document.getElementById('pricingSection');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to /home with a hash so that the Homepage can auto-scroll.
      navigate('/home#pricing');
    }
  };

  // Render the navigation links inside the drawer (for mobile)
  const renderDrawerLinks = () => (
    <Box
      sx={{
        width: 250,
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Link onClick={handlePricingClick} sx={classes.navLink}>
        Pricing
      </Link>
      <Link onClick={() => setLoginModalOpen(true)} sx={classes.navLink}>
        Login
      </Link>
      <Link onClick={() => setSignupModalOpen(true)} sx={classes.navLink}>
        Sign Up
      </Link>
    </Box>
  );

  return (
    <>
      <Box sx={classes.header}>
        {/* Left Section: Brand */}
        <Box sx={classes.headerLeft}>
          <Link component={RouterLink} to="/" sx={classes.brandLink}>
            IntenceAI
          </Link>
        </Box>

        {/* Right Section: Navigation Links */}
        <Box sx={classes.headerRight}>
          {/* Desktop Navigation: Visible on md and up */}
          <Box sx={classes.navLinksContainer}>
            <Link onClick={handlePricingClick} sx={classes.navLink}>
              Pricing
            </Link>
            <Link onClick={() => setLoginModalOpen(true)} sx={classes.navLink}>
              Login
            </Link>
            <Link onClick={() => setSignupModalOpen(true)} sx={classes.navLink}>
              Sign Up
            </Link>
          </Box>

          {/* Mobile Navigation: Hamburger Menu on xs to sm */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton onClick={toggleDrawer(true)} aria-label="Open Menu">
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
            >
              {renderDrawerLinks()}
            </Drawer>
          </Box>
        </Box>
      </Box>
      {/* Render the modals */}
      <LoginModal
        open={loginModalOpen}
        onClose={() => setLoginModalOpen(false)}
      />
      <SignupModal
        open={signupModalOpen}
        onClose={() => setSignupModalOpen(false)}
      />
    </>
  );
}

export default Header;
